/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect } from "react";
import { Modal } from "reactstrap";
import DOMPurify from "dompurify";
import crose from "../../assets/images/icons/crose.svg";
import submit from "../../assets/images/icons/submit.svg";
import useTimeCounter from "./hooks/useTimeCounter";
import { addTargetBlank } from "../../utils/commonFunctions";

function AnnoucementModel({ isOpen, toggle, onClosed, onClick, activeAnnouncement, title = "Announcement" }) {
  useEffect(() => {
    const timerid = setTimeout(() => {
      addTargetBlank("target-blank-class");
    }, 1000);
    return () => {
      clearTimeout(timerid);
    };
  }, []);
  const { seconds, minutes, hours, days } = useTimeCounter(activeAnnouncement.date, activeAnnouncement.time);
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered fade={false} onClosed={onClosed} backdropClassName="signupModalWrapBackdrop" className="">
      <span onClick={onClosed} className="signupCroseBtn position-absolute end-0" style={{ bottom: "100%" }}>
        <img src={crose} alt="crose" />
      </span>
      <div className="modal-body blackListModalWrap text-center text-white" style={{ background: activeAnnouncement.color, borderRadius: "20px" }}>
        <h4>{title}</h4>
        <p
          className="target-blank-class"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(activeAnnouncement?.announcement),
          }}
        />
        {activeAnnouncement.timer ? (
          <div className="d-flex justify-content-center">
            {!!days && (
              <div className="timebox py-2 px-3 w-auto fw-bold mr-2">
                <span className="text-xl">{days}</span>
                <span className=""> Days</span>
              </div>
            )}
            <div className="timebox py-2 px-3 w-auto fw-bold">
              <span className="text-xl">{hours}</span>
              <span className=""> Hrs</span>
            </div>
            <div className="timebox py-2 px-3 w-auto fw-bold mx-2">
              <span className="text-xl">{minutes}</span>
              <span className=""> Mins</span>
            </div>
            {!days && (
              // {days && (
              <div className="timebox py-2 px-3 w-auto fw-bold">
                <span className="text-xl">{seconds}</span>
                <span className=""> Secs</span>
              </div>
            )}
          </div>
        ) : null}
        {activeAnnouncement?.link && (
          <ul className="modalBtns text-center justify-content-center">
            <li>
              <button type="submit" onClick={onClick} className="success">
                Continue
                <img src={submit} alt="submit" />
              </button>
            </li>
          </ul>
        )}
      </div>
    </Modal>
  );
}
export default AnnoucementModel;
